/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPaintBucket = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M21.935 11.98 12 21.913 2.107 12.02l8-8.5-1.314-1.314L10.207.793l1.99 1.99zM11.542 4.914 5.814 11h12.17zM21.5 15l1.297 2.5c.577 1.111-.144 2.5-1.297 2.5s-1.874-1.389-1.297-2.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPaintBucket as PaintBucket };
